import { Navigate, Route, Routes } from 'react-router-dom'
import { Board } from './components/Board'
import type { ScreenId } from './lib/programs'

// The URL segment is the TV's address; the screen id is the layout (build-guide §2).
// The two are crossed on the owner's request (2026-09-16): /1 shows screen 2 and /2
// shows screen 1. scripts/shoot.mjs mirrors this table.
export const SCREEN_AT_ROUTE: Record<'/1' | '/2', ScreenId> = { '/1': '2', '/2': '1' }

// Two routes, one per TV. Anything else lands on /1 rather than on a 404 —
// a typo in the TV's "Play via URL" field must not leave the wall blank.
export default function App() {
  return (
    <Routes>
      <Route path="/1" element={<Board screen={SCREEN_AT_ROUTE['/1']} />} />
      <Route path="/2" element={<Board screen={SCREEN_AT_ROUTE['/2']} />} />
      <Route path="*" element={<Navigate to="/1" replace />} />
    </Routes>
  )
}
